module.exports = __webpack_public_path__ + "img/green_049.3e8d0f66.png";